<template>
    <div class="card">
    </div>
</template>
<script>
import CreateUser from './CreateUser'
import UpdateUser from './UpdateUser'
import UploadUserData from './UploadUserData'
export default {
  components: {
    CreateUser,
    UpdateUser,
    UploadUserData
  },
  data () {
    return {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User/User.vue